import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/slideshare': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M249.4 211.4C249.4 243.2 221.7 269.2 187.7 269.2 153.7 269.2 126 243.2 126 211.4 126 179.4 153.7 153.7 187.7 153.7 221.7 153.7 249.4 179.4 249.4 211.4zM503.7 261.4C485.4 284 450.6 311.7 397.4 333.4 453.7 525.2 260 555.7 263.1 457.4 263.1 459.2 262.9 404.6 262.9 364 258.6 363.2 254.3 362 249.1 360.9 249.1 401.7 248.9 459.2 248.9 457.4 252 555.7 58.3 525.2 114.6 333.4 61.4 311.7 26.6 284 8.3 261.4-0.9 247.7 9.1 233.2 24.3 243.7 26.3 245.2 28.6 246.6 30.6 248V49.7C30.6 22.3 51.1 0 76.6 0H435.7C461.2 0 481.7 22.3 481.7 49.7V248L487.7 243.7C502.9 233.2 512.9 247.7 503.7 261.4zM457.2 72.3C457.2 39.4 446.6 26.6 416.3 26.6H98.6C66.8 26.6 58 37.4 58 72.3V264.6C125.7 300 183.7 293.7 215.4 292.6 228.9 292.3 237.4 294.9 242.6 300.3 244.3 302 252.6 309.7 262.9 317.4 264 301.7 272.9 291.7 296.6 292.6 328.9 294 388.3 300.3 457.2 262.9V72.3zM331.1 153.7C297.1 153.7 269.4 179.4 269.4 211.4 269.4 243.2 297.1 269.2 331.1 269.2 365.4 269.2 392.9 243.2 392.9 211.4 392.9 179.4 365.4 153.7 331.1 153.7z'
      }
    ]
  }
})
